import { observer } from "mobx-react"
import React, { useEffect } from "react"
import HyperDiv from "./HyperDiv/HyperDiv"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import useScreenType from "../Hooks/useScreenType"
import DropdownOptionButton from "./DropdownOptionButton"
import { ILanguage } from "./LanguageSelect"
import {
	TLanguageSections,
	TLanguageValues,
} from "components/ProjectSpecificComponents/Interfaces/GlobalInterface"
import { useTranslation } from "react-i18next"
import DropdownButton from "./DropdownButton"

interface LanguageSelectorProps {
	type: TLanguageSections
	onClose?(): void
	mobile?: boolean
}

const options: ILanguages[] = [
	{ value: "en", label: "English" },
	{ value: "lv", label: "Latviešu" },
]

const InputLanguageSelect = observer(({ type, onClose, mobile = false }: LanguageSelectorProps) => {
	const formStore = useFormStore()
	const { isMobile } = useScreenType()
	const { i18n } = useTranslation()
	const selectedLanguage = formStore[type]

	const languages: ILanguages[] = [...options].sort((a, b) => a.label.localeCompare(b.label))

	useEffect(() => {
		handleLanguageSelect(i18n.language == "lv" ? "lv" : "en")
	}, [i18n.language])

	const handleLanguageSelect = (value: TLanguageValues) => {
		switch (type) {
			case "newRequestLanguage":
				formStore.setNewRequestLanguage(value)
				break
			case "requestTableLanguage":
				formStore.setRequestTableLanguage(value)
				break
			case "savedRequestLanguage":
				formStore.setSavedRequestLanguage(value)
				break
			case "settingsLanguage":
				formStore.setSettingsLanguage(value)
				break
			default:
				break
		}
	}

	return (
		<HyperDiv direction="column">
			<DropdownOptionButton
				style={{
					padding: "0.2em 0.45em",
					color: formStore.settingsData.personalize.colorButton,
				}}
				Options={
					<>
						{languages.map(({ label, value }) => {
							return (
								<React.Fragment key={label}>
									<DropdownButton
										small
										onClick={() => handleLanguageSelect(value)}
										children={value}
										style={{
											color: formStore.settingsData.personalize.colorButton,
										}}
									/>
								</React.Fragment>
							)
						})}
					</>
				}
				children={selectedLanguage}
			/>
		</HyperDiv>
	)
})

export default InputLanguageSelect
export interface ILanguages {
	value: TLanguageValues
	label: string
}
